import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useForm, useWatch } from 'react-hook-form';
import { useGetStartedContext } from '../../../contexts/GetStarted';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { forwardUrlParams } from '../../../utils/url';
import { RevenueProps } from './types/revenue-props';
import GetStartedTemplate from './GetStartedTemplate';
import RadioGroup from '../../BuildingBlocks/Form/RadioGroup';

export default function Revenue({
  progressBarPath = undefined,
  backButtonPath,
  continuePath,
}: RevenueProps) {
  const history = useHistory();
  const { setValue, control, handleSubmit } = useForm();
  const selectedOption = useWatch({ control, name: 'salesRevenue2' });
  const { revenue, setRevenue, setPassedMinRevenue } = useGetStartedContext();
  const { trackEvent } = useEventTrackerContext();

  const questions = {
    0: { id: '0', text: '0 - $8,000', dataAutomationId: '0' },
    8000: { id: '8000', text: '$8,001 - $50,000', dataAutomationId: '8000' },
    50000: {
      id: '50000',
      text: '$50,001 - 200,000',
      dataAutomationId: '50000',
    },
    200000: { id: '200000', text: '$200,001+', dataAutomationId: '200000' },
  };

  useEffect(() => {
    if (revenue && !selectedOption) {
      setValue('salesRevenue2', revenue);
    }
    // eslint-disable-next-line
  }, [revenue]);

  useEffect(() => {
    if (selectedOption === questions[0].id) {
      setPassedMinRevenue(false);
    } else {
      setPassedMinRevenue(true);
    }
    if (selectedOption) {
      setRevenue(selectedOption);
      trackEvent({
        event: 'sales_revenue',
        revenue: questions[selectedOption]?.text,
      });
    }
    // eslint-disable-next-line
  }, [selectedOption]);

  return (
    <GetStartedTemplate
      title="What was your average monthly sales revenue in the last 3 months?"
      progressBarPath={progressBarPath}
      backClick={() =>
        history.push({
          pathname: backButtonPath,
          search: forwardUrlParams(),
        })
      }
      continuePath={continuePath}
      disable={!selectedOption}
      control={control}
      setValue={setValue}
      handleSubmit={handleSubmit}
    >
      <RadioGroup
        groupId={'salesRevenue2'}
        options={Object.values(questions)}
        setValue={setValue}
        useWatch={useWatch}
        control={control}
      />
    </GetStartedTemplate>
  );
}
